<div class="ui-component" [ngClass]="component | componentClasses">
  <div class="ui-component__content"
       [ngClass]="{'container-lg' : brand.network == 'WTG'}">
    <div class="ui-component__content-wrapper">
      <div class="oto-swiper-wrapper">
        <swiper [config]="config" [(index)]="swiperIndex">
          <ng-container>
            <ng-content></ng-content>
          </ng-container>
        </swiper>
      </div>
      <div class="slider-wrap__engine slider-wrap__engine--shadow">
        <div #engine></div>
      </div>
    </div>
  </div>
</div>

